/*
 *  Developed by CQ Inversiones SAS. Copyright (c) 2024. All rights reserved.
 *  Desarrollado por CQ Inversiones SAS. Copyright (c) 2024. Todos los derechos reservados.
 */

/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez
 * Date:         22/05/24 - 19:08:00
 * Module name:  user-customer.service
 * File name:    user-customer.service.ts
 * IDE:          WebStorm
 */
import {Injectable} from '@angular/core';
import {MkadBaseService, URLS_SERVICE} from '@shared/services';
import {UserCustomerDataInterface} from '@shared/interface';

@Injectable()
export class MkadUserCustomersService extends MkadBaseService {
  private readonly customer = URLS_SERVICE.meerkad.customer;
  private readonly users = URLS_SERVICE.meerkad.user;

  getCustomer() {
    return this.http.post<UserCustomerDataInterface>(this.customer.base + this.users.base + this.customer.base);
  }

}
